import React from 'react'
import Modal from '../../modals/wrapper'
import useCourse from '../../../hooks/use-course'
import Details from './details'
import BusyModal from '../../modals/busy'
import ErrorModal from '../../modals/error'
import EnrollButton from './enroll-button'
import DropButton from './drop-button'
import PreviewScheduleButton from './preview-schedule-button'
import MessageFacilitatorButton from './message-facilitator-button'
import ViewConflictsButton from './view-conflicts-button'
import EnrollabilityLabel from './enrollability-label'
import DropabilityLabel from './dropability-label'


const ExperienceDetailsModal = ({
    experienceId,
    onHide = () => {},
}) => {
    
    const { course: experience, isBusy: isLoading } = useCourse({ id: experienceId })

    if (isLoading) {
        return (<BusyModal title='Loading experience...' />)
    }

    if (!experience) {
        return (
            <ErrorModal onHide={onHide}>
                Experience not found
            </ErrorModal>
        )
    }
    
    return (
        <Modal
            closeButton
            onHide={onHide}
            closeStyle={{ color: 'white' }}
        >
            <div style={{ minHeight: '300px'}}>
                <div
                    style={{
                        backgroundColor: 'rgb(0, 105, 217)',
                        height: '130px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        padding: '40px',
                        paddingBottom: '5px',
                    }}
                >
                    <div style={{ color: 'white', fontSize: '1.2em' }}>
                        <strong>{experience.name}</strong>
                    </div>
                </div>
                <div style={{ padding: '40px'}}>
                    <Details experience={experience} /> 
                    {!experience.isEnrolled && <EnrollabilityLabel experience={experience} />}
                    {experience.isEnrolled && <DropabilityLabel experience={experience}  />}
                    <div style={{ padding: '20px'}}>
                        <ViewConflictsButton visible={!experience.isEnrolled} experience={experience} />
                        <EnrollButton experience={experience} onEnrolled={onHide} />
                        <DropButton experience={experience} visible={experience.canDrop} onDropped={onHide} />
                        <MessageFacilitatorButton experience={experience} />
                        <PreviewScheduleButton visible={!experience.isEnrolled && experience.canSchedule} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ExperienceDetailsModal